var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningUploadPkg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11914",
    "data-name": "Path 11914",
    d: "M7,12a5,5,0,1,1,5-5,5,5,0,0,1-5,5ZM7,2.714A4.286,4.286,0,1,0,11.286,7,4.286,4.286,0,0,0,7,2.714Z",
    transform: "translate(-2 -2)",
    fill: "#e32a34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(4.465 2.143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3634",
    "data-name": "Rectangle 3634",
    width: 0.714,
    height: 3.929,
    transform: "translate(0.179)",
    fill: "#e32a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11915",
    "data-name": "Path 11915",
    d: "M15.036,22a.536.536,0,1,0,.536.536A.536.536,0,0,0,15.036,22Z",
    transform: "translate(-14.5 -17.356)",
    fill: "#e32a34"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningUploadPkg);
export default __webpack_public_path__ + "static/media/warning-upload-pkg.bd0f7f52424f692c3df4eb3533d55c95.svg";
export { ForwardRef as ReactComponent };